import React from 'react';
import GraduationPrincipale from './GraduationPrincipale';
import GraduationSecondaire from './GraduationSecondaire';
import Nombres from './Nombres';
// import Ligne from './CssLigne/';

export default () => {
    return (
        <main role="main" className="inner cover">
            <div className="svg">
                <svg viewBox="0 0 3000 300" preserveAspectRatio="xMinYMin meet">
                    <line
                        x1="2950"
                        y1="250"
                        x2="50"
                        y2="250"
                        strokeWidth="4"
                        strokeLinecap="round"
                        stroke="#000000"
                    />
                    <GraduationSecondaire />
                    <GraduationPrincipale />
                    <Nombres />
                </svg>
            </div>
        </main>
    );
};
